export default __webpack_public_path__ + "static/media/menu-collect.12776a80.svg";